import { render } from "./inviteUserSidebar.vue?vue&type=template&id=c0dd72e8"
import script from "./inviteUserSidebar.vue?vue&type=script&lang=js"
export * from "./inviteUserSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__